import { render, staticRenderFns } from "./PageForm.vue?vue&type=template&id=291452f6&"
import script from "./PageForm.vue?vue&type=script&lang=ts&"
export * from "./PageForm.vue?vue&type=script&lang=ts&"
import style0 from "./PageForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PageForm.vue"
export default component.exports